

// Lokalen PHP-Server starten:
// cd /Users/99grad/Webprojekte/tetronik-terminal/public
// php -S localhost:8081

var apiUrl = '';

// Host-Name ermitteln
if (process.env.IS_ELECTRON) {
	if (process.env.NODE_ENV == 'development') {
		var baseUrl = './';
	} else {
		var baseUrl = 'app://./';
	}
	
} else if (window.location.hostname == 'localhost' || window.location.hostname.indexOf('192.168') > -1) {
	
	// Wir sind lokal unterwegs: Alles bleibt lokal – außer der Zugriff auf das API-Backend
	var baseUrl = 'http://localhost:' + window.location.port + '/';
	var apiUrl = 'https://www.hansenberg.de/';
	var dataUrl = baseUrl + 'data/';
	var assetsUrl = baseUrl + 'assets/';

} else {

	// Wir sind innerhalb der LIVE-App und im Typo3-Umfeld
	var baseUrl = window.location.protocol + '//' + window.location.host + '/';
	var apiUrl = baseUrl;
	var dataUrl = (process.env.BASE_URL + 'data/') || '/typo3conf/ext/nnhansi/Resources/VueKarte/dist/data/';
	var assetsUrl = process.env.BASE_URL + 'assets/';
}


export const BASE_URL	= baseUrl;
export const API_URL	= apiUrl;
export const DATA_URL	= dataUrl;
export const ASSETS_URL	= assetsUrl;
